import { render, staticRenderFns } from "./Testpaper2.vue?vue&type=template&id=fd1805f6&scoped=true"
import script from "./Testpaper2.vue?vue&type=script&lang=js"
export * from "./Testpaper2.vue?vue&type=script&lang=js"
import style0 from "./Testpaper2.vue?vue&type=style&index=0&id=fd1805f6&prod&lang=less"
import style1 from "./Testpaper2.vue?vue&type=style&index=1&id=fd1805f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1805f6",
  null
  
)

export default component.exports